import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class AppService {
    protected categories: Array<any> = [];

    protected products: Array<any> = [];

    /**
     * Service class constructor
     */
    constructor() {}

    public getCategories(): Array<any> {
        return this.categories;
    }

    public setCategories(tree: Array<any>): void {
        tree.unshift({ id: 0, name: 'Todos los Productos' });
        this.categories = tree;
    }

    public getProducts(): Array<any> {
        return this.products;
    }

    public setProducts(list: Array<any>): void {
        this.products = list;
    }
}
